import { zetApi } from '@zet/network'

import ENDPOINTS from '../endpoints'

export async function getDocumentUploadURL(fieldId: string, hash: string) {
  const response = await zetApi.request({
    url: ENDPOINTS.documentUploadURL.endpoint,
    method: ENDPOINTS.documentUploadURL.method,
    params: {
      fieldId,
    },
    headers: {
      hash: encodeURIComponent(hash),
    },
  })

  return { results: response?.data?.data?.url ?? [] }
}
